import store from "@/store";
import { Message } from "element-ui";
// 排序处理，后端返回的数据带有一个sortNo属性，可以排序

// 处理平级路由为树结构
function toTree(data) {
  const result = [];
  const map = {};
  data.forEach(item => {
    map[item.permissionId] = item;
  });
  data.forEach(item => {
    const parent = map[item.pid];
    if (parent) {
      (parent.childList || (parent.childList = [])).push(item);
    } else if (item.pid === "0") {
      result.push(item);
    }
  });
  return result;
}
//系统权限
export const handleRoute = function(serveRoutes) {
  const flatRoutes = []; // 后端serveRoutes返回平级所有有权限的不完整路由数组，匹配本地创造完整路由对象
  let routes = []; // 最终树形路由
  const array1 = serveRoutes.filter(({ isShow }) => isShow === 1);
  const array = array1.filter(({ permissionName }) => permissionName !== "暂无项目");
  const list = array.filter(({ resourceType }) => resourceType !== 1);
  const buttonList = array.filter(({ resourceType }) => resourceType === 1);
  store.commit("saveAuthButtons", buttonList);
  for (const moduleItem of list) {
    flatRoutes.push({
      resourceType: moduleItem.resourceType,
      permissionName: moduleItem.permissionName,
      iconPath: moduleItem.iconPath,
      permissionId: moduleItem.permissionId,
      pid: moduleItem.pid,
      childList: moduleItem.resourceType === 2 ? null : [],
      permissionKey: moduleItem.permissionKey,
      location: moduleItem.location
    });
  }
  routes = toTree(flatRoutes);
  store.commit("saveFlatRoutes", flatRoutes);
  store.commit("saveAuthRoutes", routes);
  return routes;
};
//项目权限
export const handleProjectRoute = function(serveRoutes) {
  const flatProjectRoutes = []; // 后端serveRoutes返回平级所有有权限的不完整路由数组，匹配本地创造完整路由对象
  let routes = []; // 最终树形路由
  const array = serveRoutes.filter(({ isShow }) => isShow === 1);
  const list = array.filter(({ resourceType }) => resourceType !== 1);
  const buttonList = array.filter(({ resourceType }) => resourceType === 1);
  store.commit("saveAuthProjectButtons", buttonList);
  for (const moduleItem of list) {
    flatProjectRoutes.push({
      resourceType: moduleItem.resourceType,
      permissionName: moduleItem.permissionName,
      iconPath: moduleItem.iconPath,
      permissionId: moduleItem.permissionId,
      pid: moduleItem.pid,
      childList: moduleItem.resourceType === 2 ? null : [],
      permissionKey: moduleItem.permissionKey,
      location: moduleItem.location,
      sortNum:moduleItem.sortNum,
    });
  }
  routes = toTree(flatProjectRoutes);
  store.commit("saveFlatProjectRoutes", flatProjectRoutes);
  store.commit("saveAuthProjectRoutes", routes);
  return routes;
};



// .获取用户按钮权限
export function checkPermission(value) {
  let isExist = false;
  const dynamicSysButtons = store.state.router.buttonRoutes;
  const dynamicProjectButtons = store.state.router.buttonProjectRoutes;
  const dynamicButtons=dynamicSysButtons.concat(dynamicProjectButtons)
  if (
    dynamicButtons === undefined ||
    dynamicButtons === null ||
    dynamicButtons.length < 1
  ) {
    return isExist;
  }
  dynamicButtons.map(item => {
    if (item.permissionKey === value) {
      isExist = true;
      return isExist;
    }
  });
  return isExist;
}

// 使用企业禁止部分功能
export function disablePrompt() {
  const isTrial = store.state.enterprise.isTrial;
  if (isTrial&&isTrial.toString() === '1') {
    Message({
      message: "请加入正式企业后，再体验该功能",
      type: "warning",
      duration: 3 * 1000
    });
    return false;
  } else {
    return true;
  }
}
export function isTrialshow() {
  const isTrial = store.state.enterprise.isTrial;
  if (isTrial&&isTrial.toString() === '1') {;
    return false;
  } else {
    return true;
  }
}
